/**
 * ChatChannelMemberListReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * ChatChannelMemberListReq
 */
export interface ChatChannelMemberListReq {
  /** 搜索关键词 */
  q?: string
  /** 是否删除 */
  deleted?: boolean
  /** 页码 */
  page?: number
  /** 每页数量 */
  page_size?: number
  /** 排序字段 */
  order_by?: string
  /** 排序方向 */
  order?: string
  /** 创建时间范围 (start,end) */
  created_at__range?: any
  /** 更新时间范围 (start,end) */
  updated_at__range?: any
  /** 更新时间距今 (7d/1h/30m) */
  updated_at__since?: any
  /** 频道ID */
  channel_id?: string
  /** 频道类型 */
  channel_type?: string
  /** 用户ID */
  user_id?: any
  /** 成员角色 */
  role?: string
  /** 频道ID列表 */
  channel_id__in?: string[]
  /** 频道类型列表 */
  channel_type__in?: string[]
  /** 用户ID列表 */
  user_id__in?: any
  /** 成员角色列表 */
  role__in?: string[]
  /** 是否被禁 */
  banned?: boolean
  /** 是否影子封禁 */
  shadow_banned?: boolean
  /** 是否免打扰 */
  notifications_muted?: boolean
  /** 是否被邀请 */
  invited?: boolean
  /** 对线群阵营 */
  battle_side?: string
  /** 最小未读数 */
  unread_count__gte?: number
  /** 最大未读数 */
  unread_count__lte?: number
}

/**
 * ChatChannelMemberListReq Schema
 */
export const ChatChannelMemberListReqSchema: SchemaDefinition = {
  properties: {
    q: {
      description: '搜索关键词',
      format: 'string',
      type: 'string',
      label: '搜索关键词',
    },
    deleted: {
      description: '是否删除',
      format: '*bool',
      type: 'boolean',
      label: '是否删除',
    },
    page: {
      description: '页码',
      format: 'int',
      type: 'integer',
      label: '页码',
    },
    page_size: {
      description: '每页数量',
      format: 'int',
      type: 'integer',
      label: '每页数量',
    },
    order_by: {
      description: '排序字段',
      format: 'string',
      type: 'string',
      label: '排序字段',
    },
    order: {
      description: '排序方向',
      format: 'string',
      type: 'string',
      label: '排序方向',
    },
    created_at__range: {
      description: '创建时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '创建时间范围',
    },
    updated_at__range: {
      description: '更新时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间范围',
    },
    updated_at__since: {
      description: '更新时间距今 (7d/1h/30m)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间距今',
    },
    channel_id: {
      description: '频道ID',
      format: 'string',
      type: 'string',
      label: '频道ID',
    },
    channel_type: {
      description: '频道类型',
      format: 'cons.ChatChannelType',
      type: 'string',
      label: '频道类型',
    },
    user_id: {
      description: '用户ID',
      format: 'string',
      type: 'user',
      label: '用户ID',
    },
    role: {
      description: '成员角色',
      format: 'cons.ChatChannelMemberRole',
      type: 'string',
      label: '成员角色',
    },
    channel_id__in: {
      description: '频道ID列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: '频道ID列表',
    },
    channel_type__in: {
      description: '频道类型列表',
      format: '[]cons.ChatChannelType',
      items: {
        format: 'cons.ChatChannelType',
        type: 'string',
      },
      type: 'array',
      label: '频道类型列表',
    },
    user_id__in: {
      description: '用户ID列表',
      format: '[]string',
      type: 'user',
      label: '用户ID列表',
    },
    role__in: {
      description: '成员角色列表',
      format: '[]cons.ChatChannelMemberRole',
      items: {
        format: 'cons.ChatChannelMemberRole',
        type: 'string',
      },
      type: 'array',
      label: '成员角色列表',
    },
    banned: {
      description: '是否被禁',
      format: '*bool',
      type: 'boolean',
      label: '是否被禁',
    },
    shadow_banned: {
      description: '是否影子封禁',
      format: '*bool',
      type: 'boolean',
      label: '是否影子封禁',
    },
    notifications_muted: {
      description: '是否免打扰',
      format: '*bool',
      type: 'boolean',
      label: '是否免打扰',
    },
    invited: {
      description: '是否被邀请',
      format: '*bool',
      type: 'boolean',
      label: '是否被邀请',
    },
    battle_side: {
      description: '对线群阵营',
      format: 'cons.BattleSide',
      type: 'string',
      label: '对线群阵营',
    },
    unread_count__gte: {
      description: '最小未读数',
      format: '*int',
      type: 'integer',
      label: '最小未读数',
    },
    unread_count__lte: {
      description: '最大未读数',
      format: '*int',
      type: 'integer',
      label: '最大未读数',
    },
  },
  type: 'object',
}
